import React, { Component } from "react";
import Icon from "../icon";
import Link from "../link";
import { getLanguageField } from "src/utils/language";


export default class Upselling extends Component {
  render() {
    const { upselling, language } = this.props;
    return (
      <div className="text-sm">
        <p className="font-bold text-center">{getLanguageField(upselling.translations, language, "title", false)}</p>
        <p className="text-sm text-gray-400 text-center">{getLanguageField(upselling.translations, language, "description", false)}</p>
        <div className="flex flex-col gap-2 mt-4">
          {upselling.upselling_items?.map(item => {
            const { page, translations, custom_link } = item.upselling_item_id;
            const linkPrefix = `/${language === upselling.destination?.defaultLanguage?.code ? "" : `${language}/`}`;
            const pageLink = custom_link ? custom_link : getLanguageField(page?.translations, language, "slug", false);
            return (
              <Link href={`${linkPrefix}${pageLink}`} className={"font-semibold flex justify-between items-center border-2 py-2 px-4 rounded-3xl text-[color:var(--primaryColor)] border-[color:var(--primaryColor)]"}>
                <Icon icon="ArrowRight" className="invisible w-6" />
                <span>{getLanguageField(translations, language, "name", false)}</span>
                <Icon icon="ArrowRight" className="w-6"/>
              </Link>
            )
          })}
        </div>
      </div>
    )
  }
}
